import React, { useRef, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {PstatModel} from "app/model/info/pstat";
import ArcInput, {ArcInputChangeResult} from "app/components/arc/ArcInput";
import ArcFileUploader from "app/components/arc/ArcFileUploader";
import {FileInfoModel} from "app/model/common/file";
import ArcButton, {ButtonType} from "app/components/arc/ArcButton";
import {useAppDispatch} from "app/store/hook";
import {showAndHideSpinner} from "app/reducers/spinnerSlice";
import {PstatService} from "app/services/info/pstatService";
import {ResponseResultCode} from "app/model/response-api";
import {toast} from "react-toastify";
import {useTranslation} from "react-i18next";
import ObjectUtil from "app/utils/objectUtil";
import {BltnbClCd, CrudConstant, PrstsCd} from "app/model/common/code";
import ArcEditor from "app/components/arc/ArcEditor";
import {openModal} from "app/reducers/modalSlice";
import AppAlert from "app/components/common/AppAlert";
import ArcTitle from "../../../../components/arc/ArcTitle";
import ArcGrid from "../../../../components/arc/ArcGrid";
import { CoService } from "app/services/common/CoService";
import { logCd, logMsg } from "app/model/common/actvLogModel";

export default function Info004Write() {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useAppDispatch();
  const {t} = useTranslation();

  const initialModel = () => {
    return location.state ?? new PstatModel(BltnbClCd.API, PrstsCd.PROCESS);
  }
  const [model, setModel] = useState<PstatModel>(initialModel);
  const [newFiles, setNewFiles] = useState<File[]>([]);
  const [dataFiles,] = useState(setInitialDataFiles);
  const editorRef: any = useRef<typeof ArcGrid>();

  function setInitialDataFiles() {
    let files = [];
    if (location.state) {
      files = location.state.file?.files ?? [];
    }
    if (files.length > 0) {
      return files.map((m: FileInfoModel) => {
        return {name: m.realNm, size: m.size, fileId: m.fileId};
      })
    } else {
      return [];
    }
  }

  function onChangeInput(result: ArcInputChangeResult) {
    setModel({
      ...model,
      [result.name]: result.value,
    });
  }

  function handleChangeEditor(content: string) {
    setModel({
      ...model,
      pstatCtt: content,
    });
  }

  function handleExistFile(files: any[]) {
    const deletedFiles: any[] = dataFiles.filter((f: any) => !files.includes(f));
    let formFiles = model.file?.files?.map((m: FileInfoModel): FileInfoModel => {
      if (deletedFiles.findIndex((f: any) => f.fileId === m.fileId) >= 0) {
        return {...m, crud: CrudConstant.D};
      }
      return {...m};
    });
    setModel({
      ...model,
      file: {
        ...model.file,
        files: formFiles
      }
    });
  }

  function handleClickFileAdd(files: File[]) {
    setNewFiles(files);
  }

  function handleClickGoList() {
    navigate(-1);
  }

  async function handleClickDoSave() {
    if (validationForm(model)) {
      const formData: FormData = new FormData();
      const data = JSON.stringify(model);
      formData.append('data', data);
      if (newFiles.length > 0) {
        newFiles.forEach(f => formData.append('files', f));
      }

      dispatch(openModal({
        path: '/info/api/info004/form/save/confirm',
        target: AppAlert,
        confirmProps: {
          type: 'save',
          onConfirm: () => {
            dispatch(showAndHideSpinner(true));
            PstatService.getInstance().save(formData).then(response => {
              dispatch(showAndHideSpinner(false));
              if (response && ResponseResultCode.Y === response.resultCode) {
                CoService.getInstance().saveUserActvLog({
                  actvLogCd: logCd.IO,
                  logMsgCtt: !model.pstatId ? logMsg.IO.apiR.C : logMsg.IO.apiR.U,
                });

                setModel(response.data);
                toast.success(t('common.message.success.save', {title: ''}));
                navigate('/info/api/info004/detail', {state: response.data});
              }
            }).catch(() => dispatch(showAndHideSpinner(false)));
          }
        }
      }));
    }
  }

  function validationForm(param: any) {
    let check: boolean = true;

    if (ObjectUtil.isEmpty(param.titlNm)) {
      check = false;
      toast.info("제목을 입력하세요.");
    } else if (ObjectUtil.isEmpty(param.pstatCtt)) {
      check = false;
      toast.info("내용을 입력하세요.");
    }

    if (!check) {
      toast.error(t('common.message.error.checkRequired'));
      setModel((prev: PstatModel) => {
        return {
          ...prev,
          titlNm: ObjectUtil.isEmpty(prev.titlNm) ? "" : prev.titlNm,
          pstatCtt: prev.pstatCtt ?? "",
        }
      });
    }

    return check;
  }

  return (
    <div id="container">
      <div className="sub-wrap">
        <ArcTitle title="API 요청 게시판" />
        <div className="page-tit">
          <h2 className="tit">
            ※API 요청 게시판입니다. 원활한 요청 처리를 위해 아래 내용을 포함하여 상세하게 작성해 주시면 감사하겠습니다.
          </h2>
        </div>
        <div className="col-wrap">
          <div className="col-md-12">
            <div className="cont">
              <div className="tbl-st-row">
                <table>
                  <caption>API 등록</caption>
                  <colgroup>
                    <col style={{ width: '100%' }} />
                  </colgroup>
                  <tbody>
                  <tr>
                    <th className="pdt15 pdb15 pdl0 pdr0">
                      <ArcInput value={model.titlNm ?? ""}
                                onChange={onChangeInput}
                                id="titlNm"
                                name="titlNm"
                                maxLength={100}
                                placeholder="제목을 입력하세요."
                                validateMessage="제목을 입력하세요."
                                isRequired={true}
                      />
                    </th>
                  </tr>
                  <tr>
                    <td className="pdt15 pdb15 pdl0 pdr0">
                      <ArcEditor id="psstCtt"
                                 editorRef={editorRef}
                                 value={model.pstatCtt ?? ""}
                                 onChange={handleChangeEditor}
                                 savedPagePath="/info/api/info004/detail"
                                 imgServerPath={process.env.REACT_APP_URL_WP ?? ''}
                                 placeholder={`아래 내용을 참고하여 작성해 주시기 바랍니다.
1. 요청 배경 및 목적 : (예시) 내부시스템 연계, 특정 서비스 개발 등
2. 필요한 API 기능/데이터 : (예시) 특정 사용자의 실시간 에너지 사용량 데이터, 특정 기간의 탄소 배출량 합계 등
3. 요청 데이터 형식 : 필요한 데이터의 형식 (예: JSON,XML 등)이나 구조에 대한 요구사항이 있다면 기재해 주세요.

"작성해 주신 내용은 확인 후 신속하게 처리하거나 회신 드리겠습니다."`}
                      />
                    </td>
                  </tr>
                  {/*<tr>*/}
                  {/*  <td className="pdt15 pdb15 pdl0 pdr0">*/}
                  {/*    <ArcFileUploader maxFileNum={5}*/}
                  {/*                     maxFileSizeMb={90}*/}
                  {/*                     dbFileList={dataFiles}*/}
                  {/*                     dbUpload={handleExistFile}*/}
                  {/*                     onUpload={handleClickFileAdd}*/}
                  {/*    />*/}
                  {/*  </td>*/}
                  {/*</tr>*/}
                  </tbody>
                </table>
              </div>

              <div className="btns ar">
                <ArcButton type={ButtonType.save}
                           hasIcon={true}
                           onClick={handleClickDoSave}/>
                <ArcButton type={ButtonType.cancel}
                           onClick={handleClickGoList}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
